import { Link } from 'react-router-dom';

export default function ProductGallery() {
  const products = [
    {
      id: 1,
      name: 'ダイヤモンドリング',
      price: '¥180,000',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/5602039ff27197165907251fd39c362a.jpeg',
    },
    {
      id: 2,
      name: 'パールネックレス',
      price: '¥95,000',
      image: 'https://public.readdy.ai/ai/img_res/6aed9e1810a6d74b444134240c2c9108.jpg',
    },
    {
      id: 3,
      name: 'サファイアペンダント',
      price: '¥125,000',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20sapphire%20pendant%20with%20deep%20blue%20gemstone%20on%20white%20display%20stand%20soft%20studio%20lighting%20cream%20background%20luxury%20jewelry%20product%20photography%20elegant%20design%20high%20quality%20professional%20shot&width=600&height=700&seq=product3&orientation=portrait',
    },
    {
      id: 4,
      name: 'ゴールドブレスレット',
      price: '¥68,000',
      image: 'https://readdy.ai/api/search-image?query=delicate%20gold%20bracelet%20with%20refined%20chain%20design%20on%20white%20display%20stand%20soft%20studio%20lighting%20cream%20background%20luxury%20jewelry%20product%20photography%20elegant%20craftsmanship%20high%20quality%20professional%20shot&width=600&height=700&seq=product4&orientation=portrait',
    },
  ];

  return (
    <section className="py-20 lg:py-28 bg-cream-100" data-product-shop>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-semibold text-center text-brown-600 mb-16">
          人気のジュエリー
        </h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {products.map((product) => (
            <article
              key={product.id}
              className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="w-full h-80">
                <img
                  src={product.image}
                  alt={`${product.name} - 岡山のジュエリーおかやま`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-xl font-serif font-semibold text-brown-600 mb-2">
                  {product.name}
                </h3>
                <p className="text-lg font-serif text-brown-400">
                  {product.price}
                </p>
              </div>
            </article>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <Link
            to="/shop"
            className="inline-block px-10 py-4 border-2 border-brown-400 text-brown-600 rounded-lg hover:bg-brown-400 hover:text-white transition-all font-serif text-lg whitespace-nowrap cursor-pointer"
          >
            すべての商品を見る
          </Link>
        </div>
      </div>
    </section>
  );
}